import React from 'react';
import css from './SwitchHorse.css';

export const HorseImage = ({ listing }) => {
    const { mainListingImage } = listing?.attributes?.publicData || {};

    return mainListingImage ? (
        <div
            className={css.badgeImgHolder}
            style={{
                backgroundImage: `url(${mainListingImage})`,
            }}
        />
    ) : null;
};
